import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { getters } from '@/modules/core/app/helpers/store';
import { AppModule } from '@/modules/core/app/constants/app.constants';

export class TapOptimizeRouteConfig extends PageRouteConfig {
  /**
   * Any contextual permissions based on route
   * @returns {boolean}
   */
  canAccessRouteFromContext() {
    const userSettings = getters.session.getUserSettings();
    return userSettings.isModuleAvailable(AppModule.TAP_OPTIMIZE) || userSettings.isRemoteLogin;
  }
}
